export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";

function normalizeTheme(theme) {
    return theme === DARK_THEME
        ? DARK_THEME
        : LIGHT_THEME;
}

export function readThemePreference({
                                        themePreferenceRepository,
                                    }) {
    if (
        !themePreferenceRepository ||
        typeof themePreferenceRepository.read !== "function"
    ) {
        return LIGHT_THEME;
    }

    return normalizeTheme(
        themePreferenceRepository.read()
    );
}

export function saveThemePreference({
                                        theme,
                                        themePreferenceRepository,
                                    }) {
    if (
        !themePreferenceRepository ||
        typeof themePreferenceRepository.save !== "function"
    ) {
        throw new TypeError(
            "themePreferenceRepository must implement save"
        );
    }

    const normalizedTheme = normalizeTheme(theme);

    themePreferenceRepository.save(normalizedTheme);

    return normalizedTheme;
}